import { gql } from '@apollo/client';

export default gql`
  mutation ImportMediaItemsFromCourse(
    $courseId: String!
    $subjectId: String!
    $mediaItemId: String!
    $input: ImportMediaItemsFromCourseInput!
  ) {
    mediaItem(courseId: $courseId, subjectId: $subjectId, input: $input)
      @rest(
        type: "MediaItem"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/videos/import"
        method: "POST"
      ) {
      NoResponse
    }
  }
`;
